<template>
  <v-footer padless color="rgba(0, 0, 0, 0.03)" class="footer">
    <v-container fluid>
      <v-row align="start" justify="space-between">
        <v-col cols="6" sm="3">
          <v-row no-gutters>
            <div @click="$router.push({ name: 'SiteHome' })">
              <span class="brand">ges</span>
              <span class="brand-italic">kitchen</span>
            </div>
          </v-row>
          <v-row no-gutters style="margin-top: 2rem;">
            <v-btn outlined rounded :to="{ name: 'Login' }">
              <span
                class="font-capitalize font-weight-light"
                style="padding: 0 1rem;"
                >Connexion</span
              ></v-btn
            >
          </v-row>
          <v-row no-gutters class="copyrigth-row">
            <span class="caption">Tout droits réservés © geskitchen.com</span>
          </v-row>
        </v-col>
        <v-col cols="6" sm="3">
          <v-row no-gutters>
            <v-btn text class="mx-3" :to="{ name: 'SiteHome' }" exact>
              <span class="font-capitalize font-weight-light">Accueil</span>
            </v-btn>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-btn text class="mx-3" :to="{ name: 'Features' }" exact>
              <span class="font-capitalize font-weight-light"
                >Fonctionnalités</span
              >
            </v-btn>
          </v-row>
          <v-row no-gutters class="mt-2">
            <v-btn text class="mx-3" :to="{ name: 'Contact' }" exact>
              <span class="font-capitalize font-weight-light"
                >Nous joindre</span
              >
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: "SiteFooter"
};
</script>

<style lang="scss" scoped>
.footer {
  padding: 2rem 0;
  border-radius: 0 5rem 0 0;
}
.brand {
  font-size: 2rem;
  cursor: pointer;
  font-weight: 800;
}
.copyrigth-row {
  margin-top: 2rem;
}
.brand-italic {
  font-size: 2rem;
  cursor: pointer;
  font-weight: 900;
  font-family: "Merriweather", serif;
  font-style: italic;
  letter-spacing: -1px;
}

@media screen and (min-width: 600px) {
  .footer {
    padding: 4rem 0;
    border-radius: 0 20rem 0 0;
  }
  .copyrigth-row {
    margin-top: 5rem;
  }
}
</style>
